module.exports = __webpack_public_path__ + "static/media/MHRP09N0024.5fc89055.svg";